import { DrayageDetailsState } from "freight/types/DrayageDetailsTypes";

export const drayageDetailsInitialState: DrayageDetailsState = {
  deliveryOrderDocumentKey: null,
  masterBolNumber: null,
  commodityTransported: null,
  deliveryOrderFileName: null,
  containerId: null,
};
